import React from 'react';
import GymPaymentsTab from './components/payments-tab';
import './style.scss';

const GymPaymentList = () => {
	return <GymPaymentsTab />;
};

export default GymPaymentList;
